import * as Cookies from "js-cookie";
import ApiData from "@/assets/ApiData"

export default {
  Debug: false,
  api: {
    token: null,
    api: null,
    isLoggedIn: false
  },
  b2b: {
    firstLoad: true,
    offers: [],
    customers: [],
    customerDictionary: {},
    offerDictionary: {},
    offerCustomers: [],
    offerCustomersCopy: [],
    settings: null,
    todayLogs: [],
    todayLogsCopy: []
  },
  messages: {
    isLoading: false,
    error: "",
    success: "",
  },

  toggleRelation(offerID, customerID) {
    let index = this.b2b.offerCustomers.findIndex(item => {
      return item.CustomerID === customerID && item.OfferID === offerID
    });
    if (index > -1) this.b2b.offerCustomers[index].IsActive = !this.b2b.offerCustomers[index].IsActive;
  },
  setAuthCookie(token) {
    Cookies.set('token', token, {expires: 20});
    this.api.token = token;
  },

  logout() {
    Cookies.remove('token');
    location.reload()
  },
  getB2bData() {
    return Promise.all([ApiData.getCustomers(), ApiData.getOffers(), ApiData.getOfferCustomers(), ApiData.getSettings(), ApiData.getTodayLog()])
      .then(data => {
        this.b2b.settings = {};
        this.b2b.offers = data[1].data.data;
        this.b2b.offers.forEach(item => {
          this.b2b.offerDictionary[item.ID] = item
        });
        this.b2b.customers = data[0].data.data;
        this.b2b.customers.forEach(item => {
          this.b2b.customerDictionary[item.ID] = item
        });
        data[3].data.data.forEach(item => {
          this.b2b.settings[item.Name] = item.Value
        });
        this.b2b.offerCustomers = data[2].data.data;
        this.b2b.offerCustomersCopy = data[2].data.data;
        this.b2b.todayLogs = data[4].data.data;
        this.b2b.todayLogsCopy = data[4].data.data;
        return Promise.resolve(true);
      })
  },

  updateRelations() {
    return ApiData.getOfferCustomers().then(resp => {
        this.b2b.offerCustomers = resp.data.data;
        this.b2b.offerCustomersCopy = resp.data.data;
        return Promise.resolve(true)
      }
    )
  },
  resetRelations() {
    this.b2b.offerCustomers = this.b2b.offerCustomersCopy;
    this.resetLogs();
  }
  ,

  getB2bSettings() {
    return ApiData.getSettings().then(resp => {
      this.b2b.settings = {};
      console.log("hey");
      resp.data.data.forEach(item => {
        this.b2b.settings[item.Name] = item.Value;
        return Promise.resolve(true)
      });
    }).catch(err => Promise.resolve(false))
  }
  ,
  filterLogs(options) {
    this.b2b.todayLogs = this.b2b.todayLogsCopy.filter((item) => {
      let hasOffer = false;
      let hasCustomer = false;
      if (options.offerID) hasOffer = item.OfferID === options.offerID;
      if (options.customerID) hasCustomer = item.CustomerID === options.customerID;
      return hasOffer || hasCustomer
    });
  }
  ,
  resetLogs() {
    this.b2b.todayLogs = this.b2b.todayLogsCopy;
  }
  ,

  filterRelations(options) {
    console.log(options);
    this.b2b.offerCustomers = this.b2b.offerCustomersCopy.filter((item) => {
      console.log(item);
      let hasOffer = false;
      let hasCustomer = false;
      if (options.offerID) hasOffer = item.OfferID === options.offerID;
      if (options.customerID) hasCustomer = item.CustomerID === options.customerID;
      return hasOffer || hasCustomer
    });
    this.filterLogs(options);
  }
  ,
  deleteCustomer(id) {
    let index = this.b2b.customers.findIndex(item => item.ID === id);
    if (index > -1) this.b2b.customers.splice(index, 1);
    this.b2b.offerCustomers = this.b2b.offerCustomersCopy.filter((item) => {
      return item.CustomerID !== id
    });
  }
  ,
  deleteOffer(id) {
    let index = this.b2b.offers.findIndex(item => item.ID === id);
    if (index > -1) this.b2b.offers.splice(index, 1);
    let offerCustomers = this.b2b.offerCustomersCopy.filter((item) => {
      return item.OfferID !== id
    });
    this.b2b.offerCustomers = offerCustomers;
    this.b2b.offerCustomersCopy = offerCustomers;
  }
  ,

  updateOfferField(id, field, value) {
    let index = this.b2b.offers.findIndex(item =>
      item.ID === id
    );
    this.b2b.offers[index][field] = value;
  }
  ,
  deleteRelation(customerID, offerID) {
    let index = this.b2b.offerCustomers.findIndex(item => {
      return item.CustomerID === customerID && item.OfferID === offerID
    });
    if (index > -1) this.b2b.offerCustomers.splice(index, 1);

  }
  ,
  makeRelation(offerID, customerID, token) {
    this.b2b.offerCustomers.push({OfferID: offerID, CustomerID: customerID, token: token});
    console.log(this.b2b.offerCustomers);
  }
  ,
  hasRelation: function (offerID, customerID) {
    let index = this.b2b.offerCustomers.findIndex(item => {
      return item.CustomerID === customerID && item.OfferID === offerID
    });
    return index > -1;
  }
  ,
  isOfferExpired(offer) {
    return new Date(offer.ValidTill).getTime() < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
  }
  ,


}



// WEBPACK FOOTER //
// ./src/assets/StoreState.js